export default "__VITE_ASSET__CBj4_tEm__"